<template>
  <transition name="fade" mode="out-in">
    <div v-if="localName && localQty > 0" class="box">
      <div class="level">
        <div class="level-left">
        <h3 class="title">
          {{ panelTitle }}
        </h3>
        </div>
        <div class="level-right">
          <shares-units v-model="isSharesPercentage"/>
          <!-- <label class="label sh-panel__label">
              Number of shares is in
          </label>
          <b-radio
            v-model="isSharesPercentage"
            :native-value="true">
            %
          </b-radio>
          <b-radio
            v-model="isSharesPercentage"
            :native-value="false">
            units
          </b-radio> -->
        </div>
      </div>
      <template v-for="n in localQty">
        <shareholders-row
          :key="`shareholders_${n}`"
          :idx="n-1"
          :is-trust="isTrust"
          :is-shares-percentage="isSharesPercentage"
          :total-shares="totalShares"
          @shareholders-change="onShareholdersChange"
        />
      </template>
      <div>Total number of shares:
        <strong>
          <span :class="totalSharesClass">
            {{ totalShares }} {{ sharesNumberUnit }}
          </span>
        </strong>
      </div>
    </div>
  </transition>
</template>

<script>
import ShareholdersRow from '@/components/KycForm/ShareholdersRow'
import SharesUnits from '@/components/SharesUnits'

export default {
  name: 'ShareholdersPanel',
  components: {
    ShareholdersRow,
    SharesUnits
  },
  props: [
    'name',
    'qty',
    'parentRowId',
    'isTrust'
  ],
  data () {
    return {
      localName: this.name,
      localQty: Number(this.qty),
      localParentRowId: this.parentRowId,
      shareholders: [],
      isSharesPercentage: true
    }
  },
  watch: {
    name () {
      this.localName = this.name
    },
    qty () {
      if (this.qty < this.localQty) {
        const diff = this.localQty - this.qty
        const removed = this.shareholders.slice(this.qty)
        removed.forEach(sh => {
          this.$emit('remove-panel', sh.id)
        })
        this.shareholders.splice(-1, diff)
        this.$emit('update-shareholders-list', this.parentRowId, this.shareholders)
      }
      this.localQty = Number(this.qty)
    },
    parentRowId () {
      this.localParentRowId = this.parentRowId
    }
  },
  methods: {
    onShareholdersChange (rowId, idx, shareholder, qty) {
      this.$set(this.shareholders, idx, shareholder)
      this.$emit('shareholders-change', rowId, shareholder, qty)
      this.$emit('update-shareholders-list', this.parentRowId, this.shareholders)
    }
  },
  computed: {
    panelTitle () {
      const entityTypeString = this.isTrust ? 'Trustees' : 'Shareholders'
      return `${entityTypeString} of ${this.localName}`
    },
    sharesNumberUnit () {
      return this.isSharesPercentage ? '%' : ''
    },
    totalShares () {
      const initialValue = 0
      return this.shareholders.reduce((acc, currValue) => {
        return acc + Number(currValue.sharesNumber)
      }, initialValue)
    },
    totalSharesClass () {
      if (this.isSharesPercentage) {
        if (this.totalShares !== 100) return 'has-text-danger'
        return 'has-text-success'
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
.sh-panel__label {
  margin-bottom: 0;
  margin-right: 0.5em;
}

</style>
